<template>
  <div class="mw-100">
    <nav id="nav" class="navbar navbar-expand-lg navbar-dark bg-theme">
      <a class="navbar-brand" href="#">Postal à Mão</a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li v-if="userProfile.isAuthenticated" class="nav-item">
            <router-link class="nav-link" to="/dashboard">{{
              $t("nav.dashboard") | title
            }}</router-link>
          </li>
          <li v-if="userProfile.isAuthenticated" class="nav-item">
            <router-link class="nav-link" to="/profile">{{
              $t("nav.profile") | title
            }}</router-link>
          </li>
          <li v-if="userProfile.isAuthenticated" class="nav-item">
            <a class="nav-link" href="#" @click="logout()">{{
              $t("nav.logout") | title
            }}</a>
          </li>
          <li v-if="!userProfile.isAuthenticated" class="nav-item">
            <router-link class="nav-link" to="/login">{{
              $t("nav.login") | title
            }}</router-link>
          </li>
          <li v-if="!userProfile.isAuthenticated" class="nav-item">
            <router-link class="nav-link" to="/register">{{
              $t("nav.register") | title
            }}</router-link>
          </li>
        </ul>
      </div>
      <LocaleSwitcher v-on:change="$emit('locale-change', $event)" />
    </nav>
  </div>
</template>
<script>
import { mapState } from "vuex";
import LocaleSwitcher from "@/components/LocaleSwitcher";
export default {
  components: {
    LocaleSwitcher
  },
  computed: {
    ...mapState(["userProfile"])
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>
